import React from 'react';
import PropTypes from 'prop-types';
import './Heading.scss';

const Heading = ({
  additionalClass,
  children,
  decorator,
  type,
  color,
  size,
}) => {
  const HeadingTag = `h${type}`;
  const decoratorClass = decorator ? `heading__${decorator}` : '';
  const colorClass = color ? `text--${color}` : '';

  return (
    <HeadingTag
      className={`heading heading--${size} ${decoratorClass} ${colorClass} ${additionalClass}`}
    >
      {children}
    </HeadingTag>
  );
};

Heading.defaultProps = {
  additionalClass: '',
  decorator: '',
  size: 'default',
  color: '',
  type: 3,
};

Heading.propTypes = {
  additionalClass: PropTypes.string,
  decorator: PropTypes.string,
  size: PropTypes.string,
  color: PropTypes.string,
  type: PropTypes.oneOf([1, 2, 3, 4, 5, 6]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default Heading;
